import _ from "lodash";
import { BookingFilterAny, BookingFilterPayload } from "../types/booking-filter";
import CommonUtils from "utilities/common-utils";
import { FilterType } from "utilities/enum-utils";
import moment from "moment";

/** Converts filters to the required BookingFilterAny type */
export function mapBookingFilters(bookingsFilter: (BookingFilterAny | BookingFilterPayload)[]): BookingFilterAny[] {
  const notEmpty = bookingsFilter.filter((filter) => !_.isEmpty(filter));

  const parsed = notEmpty
    .map((filter) => {
      if ("filter" in filter === false) {
        try {

          const entries = Object.entries(filter as unknown as Record<string, string[]>);
          const [key, value] = entries[0] ?? [];
          if (_.isUndefined(key) || _.isUndefined(value)) {
            throw new Error('Invalid filter format');
          }
          return {
            filter: key,
            values: value || [],
            selectionLabel: !_.isEmpty(value)
            ? key === FilterType.DATE_RANGE
            ? CommonUtils.getFilterText(FilterType.DATE_RANGE, [moment(value[0]), moment(value[1])])
            : CommonUtils.getFilterText(key, value)
            : CommonUtils.getFilterSettings(key).fullSelectionName,
          } as BookingFilterAny;
        }
        catch (error) {
          console.log('Error parsing filter:', filter);
          console.error(error);
        }
        return null;
      }

      return filter;
    }).filter(filter => filter !== null) as BookingFilterAny[];

  return parsed;
}